import { useState, useEffect } from "react";
import { Navbar,Container } from "react-bootstrap";
import { FiLinkedin, FiGithub } from "react-icons/fi";
import { FaHeart, FaWhatsapp,FaXTwitter } from "react-icons/fa6";
import { LuMail } from "react-icons/lu";
import "../styles/Navbar.css";

function NavBar() {
  const [activeSection, setActiveSection] = useState('');

  const handleScroll = () => {
    const sections = document.querySelectorAll('section');
    const scrollPosition = window.pageYOffset;

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      if (scrollPosition >= sectionTop - sectionHeight * 0.25 && scrollPosition < sectionTop + sectionHeight * 0.75) {
        setActiveSection(section.id);
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        data-aos="fade-right"
        data-aos-duration="1000"
      >
        <Container>
          <Navbar.Brand href="#home">
            <FaHeart/><span className="ma">.io</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <span className="navbar-text">
              <div className="social-icon">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/in/great-solomon-656397237/"
                >
                  <span>
                    <FiLinkedin />
                  </span>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/B_lovedth"
                >
                  <span>
                    <FaXTwitter />
                  </span>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/B-lovedth"
                >
                  <span>
                    <FiGithub />
                  </span>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://wa.me/+2348109882351"
                >
                  <span>
                    <FaWhatsapp />
                  </span>
                </a>
              </div>
              <a href="mailto:greatsoma2019@gmail.com" id='contact-btn'>
                <button
                  className="vvd"
                >
                  <span>
                    <LuMail />
                  </span>
                </button>
              </a>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-delay="50"
        className="mx-auto pg-links"
      >
        <a
          href="#home"
          smooth={true}
          className={
            activeSection === "home" ? " active navbar-link" : "navbar-link"
          }
        >
          Home
        </a>
        <a
          href="#about"
          className={
            activeSection === "about" ? " active navbar-link" : "navbar-link"
          }
        >
          About
        </a>
        <a
          href="#experience"
          className={
            activeSection === "experience" ? " active navbar-link" : "navbar-link"
          }
        >
          Experience
        </a>
        <a
          href="#projects"
          className={
            activeSection === "projects" ? " active navbar-link" : "navbar-link"
          }
        >
          Projects
        </a>
      </div>
    </>
  );
}
export default NavBar;
